import { FC, SVGProps } from "react";

const Star: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M20 1.61804L24.2393 14.6652L24.3515 15.0106H24.7148H38.4333L27.3348 23.0742L27.0409 23.2877L27.1532 23.6332L31.3924 36.6803L20.2939 28.6168L20 28.4033L19.7061 28.6168L8.60756 36.6803L12.8468 23.6332L12.9591 23.2877L12.6652 23.0742L1.56665 15.0106H15.2852H15.6485L15.7607 14.6652L20 1.61804Z" />
    </svg>
  );
};

export default Star;
